import defaultLoglevel from "loglevel";
import { LoggerPlugin } from "./LoggerFactory";
import { assertString } from "~/utils/assert";
import { ContextManager, ContextInstance } from "~/modules/contextManager/ContextManager";
import { InternalLoggerName } from "../Logger/LoggerName";
import { logEntryPlugin } from "../plugins/logEntryPlugin";
import { LoggerImpl } from "../Logger/LoggerImpl/LoggerImpl";
import { Logger, Loglevel } from "../Logger/Logger";
import { LoggerConfigImpl } from "./LoggerConfigImpl";

const loggerMap = new Map();

export const getLogger =
    (ctx: ContextManager) =>
    (name: InternalLoggerName | string): Logger => {
        assertString(name, "name");
        let logger = loggerMap.get(name);
        if (logger) {
            return logger;
        }
        const level = ctx.retrieveInstanceOf(ContextInstance.LoggerConfigImpl, LoggerConfigImpl).level;
        const plugins = [logEntryPlugin];
        const loglevel = plugins.reduce((instance: Loglevel, plugin: LoggerPlugin) => {
            return plugin(instance);
        }, defaultLoglevel.getLogger(name));

        logger = new LoggerImpl(loglevel);
        logger.setLevel(level);
        loggerMap.set(name, logger);
        return logger;
    };
